/* Theme JS */
Shopify.queryParams = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
function slug_data(value){
      var str = value.split("");
      for(var i = 0 ;i<str.length;i++){
        if(str[i] == str[i].toUpperCase()){
          var str_down = str[i].toLowerCase();
          str[i] = '-'+ str_down;
        }
      }
      return str.join("");
}

function roadtip(element) { 
  var tipText = element.html();
  element.bind('mouseover', function() {
    if (jQuery('.roadtip').length == 0) {
      element.before('<span class="roadtip">' + tipText + '</span>');

      var tipWidth = jQuery('.roadtip').outerWidth();
      var tipPush = -(tipWidth / 2 - element.outerWidth() / 2);
      jQuery('.roadtip').css('margin-left', tipPush);
    }
  });
  element.bind('mouseleave', function() { 
    jQuery('.roadtip').remove();
  });
}

function convert_currency(value, type) {
  var newCurrency = Currency.currentCurrency;
  var oldCurrency = shopCurrency;
    if(Currency.currentCurrency === undefined) newCurrency= 'USD';

  if(oldCurrency  === undefined )  oldCurrency = 'USD';
  if (isNaN(value)) {
    value = 0.0;
  }
  var cents = 0.0;
  var oldFormat = Currency.moneyFormats['USD'][Currency.format] || '';
            var newFormat = Currency.moneyFormats[newCurrency][Currency.format] || '';
            if (oldFormat.indexOf('amount_no_decimals') !== -1) {
              cents = Currency.convert(parseInt(value, 10) * 100, oldCurrency, newCurrency);
            } else if (oldCurrency === 'JOD' || oldCurrency == 'KWD' || oldCurrency == 'BHD') {
              cents = Currency.convert(parseInt(value, 10) / 10, oldCurrency, newCurrency);
            } else {
              cents = Currency.convert(parseInt(value, 10), oldCurrency, newCurrency);
            }
  if (type == 'nosymbol') {
    return cents; 
  }
  var my_data = Currency.formatMoney(cents, newFormat);
  return my_data;

}

/* Theme JS */
(function($) {
  "use strict"; 

  jQuery(document).ready(function($) {
    $('audio,video').mediaelementplayer({audioWidth: '100%', enableAutosize: true});
    function readMore(string, maxWords) {       
      var strippedString = $("<p>" + string + "</p>").text().trim();      
      var array = strippedString.split(" ");
      var string = array.splice(0, maxWords).join(" ");

      if(array.length > maxWords) {
        string += "...";
      }

      return string ;
    }
    //Mobile Menu
    var mobileMenuWrapper = $('.mobile-menu-container');
    mobileMenuWrapper.find('.menu-item-has-children').each(function() {
      var linkItem = $(this).find('a').first();
      linkItem.after('<i class="fa fa-plus"></i>');
    });
    //calculate the init height of menu
    var totalMenuLevelFirst = $('.mobile-menu-container > ul.nav-menu > li').length;
    var mobileMenuH = totalMenuLevelFirst * 40 + 10; //40 is height of one item, 10 is padding-top + padding-bottom;

    $('.mbmenu-toggler').on('click', function(event) {
      if (mobileMenuWrapper.hasClass('open')) {
        mobileMenuWrapper.removeClass('open');
        mobileMenuWrapper.animate({
          'height': 0
        }, 'fast');
      } else {
        mobileMenuWrapper.addClass('open');
        mobileMenuWrapper.animate({
          'height': mobileMenuH
        }, 'fast');
      }
    });
    //set the height of all li.menu-item-has-children items
    $('.mobile-menu-container li.menu-item-has-children').each(function() {
      $(this).css({
        'height': 40,
        'overflow': 'hidden'
      });
    });
    $(".filter-checkbox").click(function(event) {
      /* Act on the event */
      window.location.href = $(this).parent('span').next('a').prop('href');
    });
    function modal_cart(pid,quantity){
      $("#loading").show();
      $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'json',
        data: {
          quantity: quantity, 
          id: pid 
        },
        success: function(response) {
          swal({type:'success', 
                timer: 2000,   
                showConfirmButton: false,
                title: "Good shop!", 
                text: "Added success to your cart !"
               });
          //swal("Good shop!", "Added success to your cart !", "success");
          $("#modal-cart").show(500);
          $("#modal-cart .attachment-shop_thumbnail").attr('src',response.image);
          $("#modal-cart .product-info h4").text(response.title);
          $("#modal-cart .special-price span.amount").html(convert_currency(response.price,'xx'));
           $.ajax({
              url: '/cart.js', 
              type: 'GET',
              dataType: 'json',
              success: function(data) {
                var $item = (data.item_count > 1) ? ' items' : ' item';
                $(".cart-quantity").text(data.item_count +$item );
                $(".cart-total .money").html(convert_currency(data.total_price,'xx')).attr('data-currency-'+Currency.currentCurrency,convert_currency(data.total_price,'xx'));
                $(".total .money").html(convert_currency(data.total_price,'xx')).attr('data-currency-'+Currency.currentCurrency,convert_currency(data.total_price,'xx'));
                var $html = '' ;
                $.each(data.items,function(index, el) {
                  $html += '<li class="cart-'+el.id+'">';
                  $html += '<a href="'+el.url+'" class="product-image">';
                  $html += '<img alt="s3" class="attachment-shop_thumbnail" src="'+el.image+'">';
                  $html += '</a>';
                  $html += '<div class="product-details">';
                  $html += '<a class="remove remove-cart"  data-pid="'+el.id+'" href="#"><i class="fa fa-times-circle"></i></a>';
                  $html += '<a href="'+el.url +'" class="product-name">'+el.title+'</a>';
                  $html += '<span class="quantity">';
                  $html += '<strong>'+el.quantity+'</strong> × <span class="amount"> <span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency(el.price,'xx')+'">'+convert_currency(el.price,'xx')+'</span></span>';
                  $html += '</span>';
                  $html += '</div>';
                  $html += '</li>';
                });
                $(".product_list_widget").html($html );
                     setTimeout(function(){
                      var data = $(".widget_shopping_cart_content p.total .money").html();
                       $(".widget_shopping_cart_content p.total .amount").html("<span class='money'>  "+ data +"</span>");
                       var data = $(".cart-toggler .amount .money").html();
                       console.log(data);
                       $(".cart-toggler .amount").html("<span class='money'>  "+ data +"</span>");
                    },2000);
                $("#loading").hide();
             
              }
            }); 
        }
      });
 
     
    }
    $("#modal-cart .close").click(function(event) {
      /* Act on the event */ 
      $("#modal-cart").hide(700); 
    }); 
    $(document).on('click', '.addsingle_add_to_cart_button', function(event) {
      event.preventDefault();
      /* Act on the event */
      var $pid = $(this).parent('form').find("#productSelect").val();
      var $quantity = parseInt($(this).parent('form').find("#Quantity").val());
      modal_cart($pid,$quantity);
      $(this).addClass('active');
    });  
    $(document).on('click', '.remove-cart', function(event) {
      event.preventDefault();
      /* Act on the event */
      var $id = $(this).data('pid');
      $.ajax({
        url:'/cart/update.js', 
        type: 'GET',
        dataType: 'json',
        data:"updates["+$id+"]=0",
        success: function(data) {
          var $item = (data.item_count > 1) ? ' items' : ' item';
          $(".cart-quantity").text(data.item_count + $item);
          $(".cart-total .money").html(convert_currency(data.total_price,'xx')).attr('data-currency-'+Currency.currentCurrency,convert_currency(data.total_price,'xx'));
          $(".total .money").html(convert_currency(data.total_price,'xx')).attr('data-currency-'+Currency.currentCurrency,convert_currency(data.total_price,'xx'));
          $(".cart-"+$id).slideUp().remove();
            setTimeout(function(){
                      var data = $(".widget_shopping_cart_content p.total .money").html();
                       $(".widget_shopping_cart_content p.total .amount").html("<span class='money'>  "+ data +"</span>");
                       var data = $(".cart-toggler .amount .money").html();
                       console.log(data);
                       $(".cart-toggler .amount").html("<span class='money'>  "+ data +"</span>");
                    },2000);
          swal({type:'success', 
                timer: 2000,   
                showConfirmButton: false,
                title: "Good shop!", 
                text: "Removed success product in your cart!"
               });
          

        }
      });
    });
    $(document).on('click', '.add_to_cart_button', function(event) {
      /* Act on the event */
      var $pid = $(this).data('pid');
      var $quantity = 1 ;
      if(!$(this).hasClass('button-select')){
        event.preventDefault();
        modal_cart($pid,$quantity);
        $(this).addClass('active');
      }
    });
    //process the parent items
    function compare_to_sidebar(json_data){
      var $html = '';
      $.each(json_data,function(index, data) {

        $html +='<li class="sidebar-'+data.handle+'">';
        $html +='    <a class="product-image" href="/products/'+data.handle+'">';
        $html +='        <img src="'+data.featured_image+'">';
        $html +='    </a>';
        $html +='    <div class="product-details">';
        $html +='        <a href="/products/'+data.handle+'" class="remove sidebar-compare-remove" data-handle="'+data.handle+'"title="Remove">x</a>';
        $html +='       <a class="title product-name" href="/products/'+data.handle+'">'+data.title+'</a>';
        $html +='    </div>';
        $html +='</li>';

      });
      return $html ;
    } 
    function compare_to_table(data) {
      if (Object.keys(data).length <= 0) {
        return '';
      }
      var html = '';
      var i = 0;
      var end_check = (Object.keys(data).length - 1);
      var width_tr = (end_check > 0) ? (90 / (Object.keys(data).length)) : 90;
      var data_html = '';
      for (i = 0; i <= end_check; i++) {
        var el = data[i];
        var is_sale = false;
        if (el.compare_at_price > el.price) {
          is_sale = true
        }
        data_html = data_html + '<th class=" ' + el.handle + '">  <button type="button" class="close remove-compare center-block ' + el.handle + '" aria-label="Close" data-handle="' + el.handle + '"><span aria-hidden="true">&times;</span></button></td>';
        //Start title 
        if (i == 0) {
          html = html + '<tr >';
          html = html + '<th width="15%" class="product-name" > Product name </th>';
        }
        html = html + '<td width="' + width_tr + '%"  class="' + el.handle + '"> ' + el.title + '  </td>';
        if (i >= end_check) {
          html = html + '</tr>';
        }
        // End Title 
      }
      for (i = 0; i <= end_check; i++) {
        var el = data[i];
        var is_sale = false;
        if (el.compare_at_price > el.price) {
          is_sale = true
        }
        if (i == 0) {
          html = html + '<tr>';
          html = html + '<th width="15%" class="product-name" > Product image </th>';

        }
        // start product image
        html = html + '<td width="' + width_tr + '%" class="' + el.handle + '"> <img src="' + el.featured_image + '"  width="150"/> ' + '<div class="product-price"> ';
        if (is_sale) {
          html = html + '<strong></strong>' + '<span class="price-sale"><span class="money" data-currency-' + Currency.currentCurrency + '="' + convert_currency(el.price, '11') + '">' + convert_currency(el.price, '11') + '</span></span>';
        } else {
          html = html + '<span class="price-sale"><span class="money" data-currency-' + Currency.currentCurrency + '="' + convert_currency(el.price, '11') + '">' + convert_currency(el.price, '11') + '</span></span>';
        }
        if (convert_currency(el.compare_at_price, 'nosymbol') > 0) {
          html = html + '<span class="visually-hidden"></span> <s>' + convert_currency(el.compare_at_price, '11') + '</s>';
        }
        html = html + '</div>';
        //convert_currency(el.price,'3');
        if (el.variants.length > 1) {
          html = html + '<a href="#" class="button" onclick="location.href=\'/products/' + el.handle + '\'">Select Options</a>';
        } else {
          html = html + '<a href="#" title="Add to Cart" data-pid="' + el.variants[0].id + '" class="add-to-cart button add_to_cart_button">Add to Cart</a>';
        }
        html = html + ' </td>';

        if (i >= end_check) {
          html = html + '</tr>';
        }
        // End product image
      }
      for (i = 0; i <= end_check; i++) {
        var el = data[i];
        var is_sale = false;
        if (el.compare_at_price > el.price) {
          is_sale = true
        }
        if (i == 0) {
          html = html + '<tr>';
          html = html + '<th width="15%" class="product-name" > Product description </th>';

        }
        html = html + '<td width="' + width_tr + '%" class="' + el.handle + ' "> <p class="description-compare"> ' + readMore( el.description,100) + ' </p> </td>';
        if (i >= end_check) {
          html = html + '<tr>';
        }

      }
      for (i = 0; i <= end_check; i++) {
        var el = data[i];
        var is_sale = false;
        if (el.compare_at_price > el.price) {
          is_sale = true
        }
        if (i == 0) {
          html = html + '<tr>';
          html = html + '<th width="15%" class="product-name" > AVAILABILITY </th>';

        }

        var avai_stock = (el.available) ? 'Available In stock' : 'Unavailable In stock';
        html = html + '<td   width="' + width_tr + '%" class="available-stock ' + el.handle + '"> <p> ' + avai_stock + ' </p> </td>';
        if (i >= end_check) {
          html = html + '<tr>';
        }

      }
      $(".th-compare").html('<td>Action</td>' + data_html);
      $(".compare-list-data").html(html);
    }
    $('.mobile-menu-container li.menu-item-has-children').each(function() {
      var parentLi = $(this);
      var dropdownUl = parentLi.find('ul.sub-menu').first();

      parentLi.find('.fa').first().bind('click', function() {
        //set height is auto for all parents dropdown
        parentLi.parents('li.menu-item-has-children').css('height', 'auto');
        //set height is auto for menu wrapper
        mobileMenuWrapper.css({
          'height': 'auto'
        });

        var dropdownUlheight = dropdownUl.outerHeight() + 40;

        if (parentLi.hasClass('opensubmenu')) {
          parentLi.removeClass('opensubmenu');
          parentLi.animate({
            'height': 40
          }, 'fast', function() {
            //calculate new height of menu wrapper
            mobileMenuH = mobileMenuWrapper.outerHeight();
          });
          parentLi.find('.fa').first().removeClass('fa-minus');
          parentLi.find('.fa').first().addClass('fa-plus');
        } else {
          parentLi.addClass('opensubmenu');
          parentLi.animate({
            'height': dropdownUlheight
          }, 'fast', function() {
            //calculate new height of menu wrapper
            mobileMenuH = mobileMenuWrapper.outerHeight();
          });
          parentLi.find('.fa').first().addClass('fa-minus');
          parentLi.find('.fa').first().removeClass('fa-plus');
        }

      });
    });
    //Quick view
    $(".lost_password").click(function(event) {
      event.preventDefault();
      /* Act on the event */
      $("#RecoverPasswordForm").show();
      $("#customer_login").hide();

      return false;

    });
    $(".show-login").click(function(event) {
      /* Act on the event */
         event.preventDefault();
      /* Act on the event */
      $("#RecoverPasswordForm").hide();
      $("#customer_login").show();

      return false;
    });
    $(document).on('click', '.sidebar-compare-remove', function(event) {
      event.preventDefault();
      /* Act on the event */ 
      var $handle = $(this).data('handle');

      $.each(compare, function(index, el) {
        if (el == $handle ) {
          compare[index] = "";
          delete compare[index];
        }
      });       
      compare_list = compare;
      $("[data-pid='"+$handle+"']").removeClass('added').text('add to compare');
      $('.compare-button a').each(function() {
          roadtip($(this));
      });
      $("#compare-sidebar li.sidebar-"+$handle).slideDown().remove();
      storage.set('compare', compare);
      $("."+$handle).slideUp(600).remove();
      swal({
        title: "Delete success",
        text: "I will close in 2 seconds.",
        timer: 2000,
        showConfirmButton: false,
        type: "success"
      });

    });
    $(document).on('click', '.clear-all-compare', function(event) {
      event.preventDefault();
      /* Act on the event */
      storage.set('compare', []);
      compare_list = [];
      $("#compare-sidebar").html('<li> No product added to compare </li>');
      swal({
        title: "Delete success",
        text: "I will close in 2 seconds.",
        timer: 2000,
        showConfirmButton: false,
        type: "success"
      });
    });
    $(document).on('click', ".quickview", function(event) {
     // event.preventDefault();
      /* Act on the event */
      $("#loading").show();
       
      var this_handle = $(this).data('handle');
      var url = "/products/" + this_handle + "?view=quickview";
      $("#quickview-content").load(url, function() {
        if($("#quickview-content").find(".product-single-_variants").children('option').length <=1){
              $(".product-single-_variants").hide();
            }
      // var price = $("#quickview-content .money").html();
      // console.log(price);
     // price = price.replace(/[^0-9.]/g, '');
     //  price = convert_currency(price,'xx');
      // console.log(price);
          var newCurrency = jQuery('[name=currencies]').val();

         Currency.convertAll(defaultCurrency, newCurrency);
      // $("#quickview-content .money").html(price);
    
        $('.quick-thumbnails a').each(function() {
          var quickThumb = $(this);
          var quickImgSrc = quickThumb.attr('href');

          quickThumb.on('click', function(event) {
            event.preventDefault();
            
            $('.main-image').find('img').attr('src', quickImgSrc);

          });
        });

        /*thumbnails carousel*/
        $('.quick-thumbnails').slick({
          slidesToScroll: 1,
          slidesToShow: 4
        });
       
         $("#loading").hide(500);
      });
    });
    $('.view-compare').click(function(event) {
      /* Act on the event */
      $("#compare-wrapper").modal('show');
      return false;
    });
    $(document).on('click', ".wishlist", function(event) {
      var $this = $(this);
      event.preventDefault();
      /* Act on the event */
      var myid = $(this).data('form');
      var args = $("input[value='" + myid + "']").first().parent('form').serialize();
      $("#loading").show();
      $.ajax({
        url: '/contact',
        type: 'POST',
        dataType: 'html',
        data: args,
        success: function(data, status) {
          if (status == "success") {
            $('[data-form="'+myid+'"]').hide(600).next('a.added-wishlist').css({visibility:'visible',display:'block'});
            $("#loading").hide(500);
            swal({
              title: "Good job!",
              text: "Added success to wishlist!",
              timer: 2000,
              type:"success",
              showConfirmButton: false
            });
          } else {
            $("#loading").hide(500);
            sweetAlert( 
            {
              type:"error",
              title:"Opps",
              text:"Please <a class='alert-bold' href='/account/login'>login</a> to use wishlist!",
              html:true
            });
          }
        }
      });
    });
    $(document).on('click', '.remove_from_wishlist', function(event) {
      event.preventDefault();
      /* Act on the event */
      event.preventDefault();
      $("#loading").show();
      /* Remove product from wishlist*/
      var $this = $(this);
      var value = $(this).data('wid');
      var $handle = $(this).data('handle');
      $('.remove-value').val(value);
      var args = $('.contact-form').serialize();
      $.ajax({
        url: $('.contact-form').attr('action'),
        type: 'POST',
        dataType: 'html',
        data: args,
        success: function(data, status) {
          if (status == "success") {
            $("tr.wishlist-" + $handle).slideUp(600).remove();
            $("#loading").hide(500);
            swal({
              title: "Good job!",
              text: "Remove success.",
              timer: 2000,
              type:"success",
              showConfirmButton: false
            });
          } else {
            $("#loading").hide(500);
          }
        }
      });
    });

    $(document).on('click', ".wishlist-login", function(event) {
      event.preventDefault();
      /* Act on the event */
      sweetAlert( {
              type:"error",
              title:"Opps",
              text:"Please <a  class='alert-bold' href='/account/login'>login</a> to use wishlist!",
              html:true
            });
    });
    $(document).on('click', ".wishlist-addtocart", function(event) {
      event.preventDefault();
      /* Add product in wishlist to cart*/
      var $this = $(this);
      $("#loading").show();
      var value = $(this).data('wid');
      $('.product-select').val(value);
      var args = $('.add-variant').serialize();
      $.ajax({
        url: $('.add-variant').attr('action'),
        type: 'POST',
        dataType: 'html',
        data: args,
        success: function(data, status) {
          if (status == "success") {
            $this.hide(600).next('button.wishlist-addedtocart').removeClass('wishlist-addedtocart').show(700);
            $("#loading").hide(500);
            swal("Success!", "Added success to cart!", "success");
          } else {
            $("#loading").hide(500);
            sweetAlert("Oops...", "An error occurred when add to cart!", "error");
          }
        }
      });
    }); 
    /* Compare Product**/
    var storage = $.localStorage;
    var compare = {};
    var total_compare = 3;
    if (storage.isSet('compare')) {
      compare = storage.get('compare');
    } else {
      storage.set('compare', {});
    }

    // if ($("body").hasClass('page.compare')) {


    if (!$.isEmptyObject(compare)) {
      var list_id = '';
      var json_compare = [];
      var check_end = 0;
      var compare_size = (Object.keys(compare).length - 1);
      compare_list = compare;
      $.each(compare, function(index, el) {
        $("[data-pid='"+el+"']").addClass('added').text('Added to compare');
        var json_url = "/products/" + el + ".js";
        if ($.trim(el) != "") {
          jQuery.getJSON(json_url, function(product) {
            json_compare[check_end] = product;
            if (check_end >= compare_size) {
              $("#compare-sidebar .no-compare").hide();
              compare_to_table(json_compare);
              $("#compare-sidebar").append(compare_to_sidebar(json_compare));
            }
            check_end += 1;
          });

        }

      });
    } else {
      console.log(compare);
      $(".error-compare").show();
    }
    //  }
    $(document).on('click', '.remove-compare', function(event) {
      event.preventDefault();
      /* Act on the event */
      var $handle = $(this).data('handle');

      $.each(compare, function(index, el) {
        if (el == $handle ) {
          compare[index] = "";
          delete compare[index];
        }
      });       
      storage.set('compare', compare);
      compare_list = compare;
      $("."+$handle).slideUp(600).remove();
       $("[data-pid='"+$handle+"']").removeClass('added').text('add to compare');
       $('.compare-button a').each(function() {
          roadtip($(this));
       });
      $("#compare-sidebar li.sidebar-"+$handle).slideDown().remove();
      swal({
        title: "Delete success",
        text: "I will close in 2 seconds.",
        timer: 2000,
        showConfirmButton: false,
        type: "success"
      });
    });
    $(".compare-list-data").attr('id','compare-list');
    $(document).on('click', ".compare", function(event) {
      event.preventDefault();
      /* Act on the event */
      var $this = $(this);
      var pid = $(this).data('pid');

      compare = storage.get('compare');
      if ($.isEmptyObject(compare)) {
        compare = {};
      }


      var check_compare = true;
      if (Object.keys(compare).length >= total_compare) {
        swal({
          title: "info",
          text: "Product Added over 3 product !. Do you want go to compare page ?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#4cae4c",
          confirmButtonText: "Yes,I want view it!",
          timer: 5000,
          cancelButtonText: "Continue",
          closeOnConfirm: true
        },
        function() {
          swal({
              title: "Good job!",
              text: "Wating...",
              timer: 2000,
              showConfirmButton: false
            });
          if(jQuery(window).width()> 768 ){
            $("#compare-wrapper").modal('show');
          }else{
            window.open("/pages/compare",'_blank');
          }


        });
      } else {
        for (var i = 1; i <= 3; i++) {
          if (compare['p' + i] == "" || compare['p' + i] == undefined) {
            compare['p' + i] = pid;
            break;
          } else if (compare['p' + i] == pid) {
            $this.addClass('added');
            check_compare = false;
            swal({
              title: "info",
              text: "Product added to compare!. Do you want go to compare page ?",
                type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#4cae4c",
              confirmButtonText: "Yes,I want view it!",
              timer: 5000,
              cancelButtonText: "Continue",
              closeOnConfirm: true,
            },function() {
              swal("Success!", "Wating...", "success");
              if(jQuery(window).width()> 768 ){
                $("#compare-wrapper").modal('show');
              }else{
                window.open("/pages/compare",'_blank');
              }
            })
            break;

          }
        }
        if (check_compare) {
          storage.set('compare', compare);
          // swal("Success!", "Added success to compare!", "success");
          swal({
            title: "Success",
            text: "Added success to compare!. Do you want go to compare page ?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#4cae4c",
            timer: 5000,
            cancelButtonText: "Continue",
            confirmButtonText: "Yes,I want view it!",
            closeOnConfirm: false
          },
               function() {
            // swal("Success!", "Wating...", "success");
             swal({
              type:'success',
              title: "Good job!",
              text: "Wating...",
              timer: 2000,
              showConfirmButton: false
            });
            if(jQuery(window).width()> 768 ){
              $("#compare-wrapper").modal('show');
            }else{
              window.open("/pages/compare",'_blank');
            }
          });
          $this.addClass('add-success');
         // $this.addClass('added');
          $("[data-pid='"+pid+"']").addClass('added').text('Added to compare');
          setTimeout(function(){
            if (!$.isEmptyObject(compare)) {
              $(".error-compare").hide(20);
              var list_id = '';
              var json_compare = [];
              var check_end = 0;
              $("#compare-sidebar").empty();
              var compare_size = (Object.keys(compare).length - 1);
              console.log(compare_size);
              $.each(compare, function(index, el) {
                var json_url = "/products/" + el + ".js";
                if ($.trim(el) != "") {
                  jQuery.getJSON(json_url, function(product) {
                    json_compare[check_end] = product;
                    if (check_end >= compare_size) {
                      $("#compare-sidebar").append(compare_to_sidebar(json_compare));

                      compare_to_table(json_compare);

                    }
                    check_end += 1;
                  });
                } 
              });
            }
          }, 3000);
        }
      }
      compare_list = compare;

    });
    /** End compare */
    $(document).on('click', '.wishlist-remove', function(event) {
      event.preventDefault();
      $("#loading").show();
      /* Remove product from wishlist*/
      var $this = $(this);
      var value = $(this).data('wid');
      $('.remove-value').val(value);
      var args = $('.contact-form').serialize();
      $.ajax({
        url: $('.contact-form').attr('action'),
        type: 'POST',
        dataType: 'html',
        data: args,
        success: function(data, status) {
          if (status == "success") {
            $("tr." + value).slideUp(600);
            $("#loading").hide(500);
            swal({
              title: "Good job!",
              text: "Remove success.",
              timer: 2000,
              showConfirmButton: false
            });
          } else {
            $("#loading").hide(500);
          }
        }
      });
    });
    //Mini Cart
    $('.widget_shopping_cart').bind('mouseover', function() {
      if ($(window).width() > 1024) {
        $('.mini_cart_content').addClass('open');
        $('.cart-toggler').addClass('open');
      }
    });
    $('.widget_shopping_cart').bind('mouseleave', function() {
      if ($(window).width() > 1024) {
        $('.mini_cart_content').removeClass('open');
        $('.cart-toggler').removeClass('open');
      }
    });
    //For tablet & mobile
    $('.widget_shopping_cart').bind('click', function() {
      if ($(window).width() < 1025) {
        if ($('.mini_cart_content').hasClass('open')) {
          $('.mini_cart_content').removeClass('open');
          $('.cart-toggler').removeClass('open');
        } else {
          $('.mini_cart_content').addClass('open');
          $('.cart-toggler').addClass('open');
        }
      }
    });

    //Tooltip
    $('.yith-wcwl-add-button a').each(function() {
      roadtip($(this));
    });
    $('.compare-button a').each(function() {
      roadtip($(this));
    });
    $('.add-to-cart a').each(function() {
      roadtip($(this));
    });
    $('.detail-link.quickview .fa').each(function() {
      roadtip($(this));
    })

    //Brand logos carousel
    $('.brands-carousel').slick({
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 2,
      speed: 2000,
      easing: 'linear',
      autoplay: true,
      autoplaySpeed: 5000,
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });

    //Product widgets carousel
    $('.home-products .shop-products').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 700,
      easing: 'linear',
      autoplay: false
    });

    //layout 4
    $('.latest-posts.layout4 .posts-carousel').slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      speed: 2000,
      easing: 'linear',
      autoplay: false,
      autoplaySpeed: 3000,
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 760,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });
    $('.posts-carousel').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      speed: 2000,
      easing: 'linear',
      autoplay: false,
      autoplaySpeed: 3000,
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 960,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 760,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });

    //Products carousel layout 2
    $('.products-carousel .shop-products').slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      speed: 700,
      easing: 'linear',
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 960,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 760,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });



    

    //Testimonials carousel
    $('.testimonials-list').slick({
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      speed: 2000,
      easing: 'linear',
      autoplay: true,
      autoplaySpeed: 3000,
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 760,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });

    //Cross-sells Products carousel
    $('.cross-carousel .shop-products').slick({
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      speed: 700,
      easing: 'linear'
    });

    //Image zoom
    $('.zoom_in_marker').on('click', function() {
      $.fancybox({
        href: $('.woocommerce-main-image').attr('href'),
        openEffect: 'elastic',
        closeEffect: 'elastic'
      });
    });

    //Upsells Products carousel
    $('.upsells.products .shop-products').slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      speed: 700,
      easing: 'linear',
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 960,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 760,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });

    //Related Products carousel
    $('.related.products .shop-products').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 700,
      easing: 'linear',
    });

    //Projects carousel
    $('.our-projects #projects_list').slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      speed: 700,
      easing: 'linear',
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 960,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 760,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });
     var view_mode  = $.localStorage;
     var get_view_mode = view_mode.get('view_mode');
      setTimeout(function(){
           if(get_view_mode == 'list'){
              $(".list").trigger('click');
             }else{
              $(".grid").trigger('click');
             }
           }, 2000);
    //Category view mode
    $('.view-mode').each(function() {
      $(this).find('.grid').on('click', function(event) {
        event.preventDefault();
        view_mode.set('view_mode','grid');
        $('.view-mode').find('.grid').addClass('active');
        $('.view-mode').find('.list').removeClass('active');

        $('.shop-products').removeClass('list-view');
        $('.shop-products').addClass('grid-view');

        $('.list-col4').removeClass('col-xs-12 col-sm-3');
        $('.list-col8').removeClass('col-xs-12 col-sm-9');
      });
      $(this).find('.list').on('click', function(event) {
        event.preventDefault();
        view_mode.set('view_mode','list');
        $('.view-mode').find('.list').addClass('active');
        $('.view-mode').find('.grid').removeClass('active');

        $('.shop-products').addClass('list-view');
        $('.shop-products').removeClass('grid-view');

        $('.list-col4').addClass('col-xs-12 col-sm-3');
        $('.list-col8').addClass('col-xs-12 col-sm-9');
      });
    });

    //Fancy box
    $(".fancybox").fancybox({
      openEffect: 'elastic',
      closeEffect: 'fade',
      beforeShow: function() {
        if (this.title) {
          // New line
          this.title += '<div class="fancybox-social">';

          // Add tweet button
          this.title += '<a href="https://twitter.com/share" class="twitter-share-button" data-count="none" data-url="' + this.href + '">Tweet</a> ';

          // Add FaceBook like button
          this.title += '<iframe src="//www.facebook.com/plugins/like.php?href=' + this.href + '&amp;layout=button_count&amp;show_faces=true&amp;width=500&amp;action=like&amp;font&amp;colorscheme=light&amp;height=23" scrolling="no" frameborder="0" style="border:none; overflow:hidden; width:110px; height:23px;" allowTransparency="true"></iframe></div>';
        }
      },
      afterShow: function() {
        // Render tweet button
        twttr.widgets.load();
      },
      helpers: {
        title: {
          type: 'inside'
        },
        overlay: {
          showEarly: false
        }
      }
    });

    //Fancy box for single project
    $(".prfancybox").fancybox({
      openEffect: 'fade',
      closeEffect: 'elastic',
      nextEffect: 'fade',
      prevEffect: 'fade',
      beforeShow: function() {
        if (this.title) {
          // New line
          this.title += '<div class="fancybox-social">';

          // Add tweet button
          this.title += '<a href="https://twitter.com/share" class="twitter-share-button" data-count="none" data-url="' + this.href + '">Tweet</a> ';

          // Add FaceBook like button
          this.title += '<iframe src="//www.facebook.com/plugins/like.php?href=' + this.href + '&amp;layout=button_count&amp;show_faces=true&amp;width=500&amp;action=like&amp;font&amp;colorscheme=light&amp;height=23" scrolling="no" frameborder="0" style="border:none; overflow:hidden; width:110px; height:23px;" allowTransparency="true"></iframe></div>';
        }
      },
      afterShow: function() {
        // Render tweet button
        twttr.widgets.load();
      },
      helpers: {
        title: {
          type: 'inside'
        },
        overlay: {
          showEarly: false
        },
        buttons: {},
        thumbs: {
          width: 100,
          height: 100
        }
      }
    });

    //push recent posts & recent comments into tabs
    $('.roadtabs li').each(function() {
      $(this).on('click', function() {
        var tabRel = $(this).attr('rel');

        $('.roadtabs .tab').removeClass('active');
        $(this).addClass('active');

        $('.widget_road_widgets').removeClass('active');
        $('#' + tabRel).addClass('active');

        $('.panel').removeClass('active');
        $('#' + tabRel).addClass('active');
      });
    });

    //Go to top
    $('#back-top').on('click', function() {
      $("html, body").animate({
        scrollTop: 0
      }, "slow");
    });


    /*thumbnail click*/
    $('.quick-thumbnails a').each(function() {
      var quickThumb = $(this);
      var quickImgSrc = quickThumb.attr('href');

      quickThumb.on('click', function(event) {
        event.preventDefault();

        $('.main-image').find('img').attr('src', quickImgSrc);
      });
    });

    /*thumbnails carousel*/
    $('.quick-thumbnails').slick({
      slidesToScroll: 1,
      slidesToShow: 4
    });

    //Product tabs carousel
    $('#shop-carousel-1, #shop-carousel-2, #shop-carousel-3, #shop-carousel-4, .rubbez-carousel').owlCarousel({
      items: 4,
      itemsDesktop: [1170, 4],
      itemsDesktopSmall: [959, 4],
      itemsTablet: [800, 3],
      itemsTabletSmall: [600, 1],
      itemsMobile: [450, 1],
      singleItem: false,
      itemsScaleUp: false,
      slideSpeed: 700,
      paginationSpeed: 800,
      autoPlay: false,
      stopOnHover: true,
      navigation: true,
      scrollPerPage: false,
      pagination: false,
      paginationNumbers: false,
      responsive: true,
      autoHeight: false,
      mouseDrag: true,
      touchDrag: false,
    });

    // focus input hiden by sarus
    $('input:text').each(function() {
      var txtval = $(this).val();
      $(this).focus(function() {
        $(this).val('')
      });
      $(this).blur(function() {
        if ($(this).val() == "") {
          $(this).val(txtval);
        }
      });
    });


    //Modal
    $('#productModal').on('shown.bs.modal');

  });

  $(window).load(function() {
    //Shuffle (blog grid layout)
    $('#shufflegrid').shuffle({
      itemSelector: '.shuffle-item'
    });

    //Projects filter with shuffle.js
    $('.list_projects #projects_list').shuffle({
      itemSelector: '.project'
    });

    $('.filter-options .btn').on('click', function() {

      var filterBtn = $(this),
          isActive = filterBtn.hasClass('active'),
          group = isActive ? 'all' : filterBtn.data('group');

      // Hide current label, show current label in title
      if (!isActive) {
        $('.filter-options .active').removeClass('active');
      }

      filterBtn.toggleClass('active');

      // Filter elements
      $('.list_projects #projects_list').shuffle('shuffle', group);
    });
  });
  // Scroll
  var currentP = 0;
  $(window).scroll(function() {
    var headerH = $('.header-container').height();
    var navH = $('.nav-container').height();
    headerH += navH;
    var scrollP = $(window).scrollTop();
    if ($(window).width() > 1024) {
      if (scrollP != currentP) {
        //Back to top
        if (scrollP >= headerH) {
          $('#back-top').addClass('show');
          $('.nav-container').addClass('ontop');
        } else {
          $('#back-top').removeClass('show');
          $('.nav-container').removeClass('ontop');
        }
        currentP = $(window).scrollTop();
      }
    }
  });
  /*---------------------
      Map
    --------------------- */ 
    $('#map').click(function () {
      $('#map iframe').css("pointer-events", "auto");
    });
    
    $( "#map" ).mouseleave(function() {
      $('#map iframe').css("pointer-events", "none"); 
    });

$("#searchform").submit(function(event) {
  /* Act on the event */
  var val = $("#ws").val();
  if(val == "" ){
     $("#ws").focus();
      event.preventDefault();
    return false;
  }
 /*---------------------
      Map
    --------------------- */ 
    $('.map-area').click(function () {
      $('.map-area iframe').css("pointer-events", "auto");
    });
    
    $( ".map-area" ).mouseleave(function() {
      $('.map-area iframe').css("pointer-events", "none"); 
    });
});
  jQuery(".panel-group.demoaccordion .panel").not('.active').click(function(){
      jQuery(".panel-group.demoaccordion .panel").removeClass('active');
      $(this).addClass('active');
  });
  setTimeout(function(){
    jQuery(".panel-group.demoaccordion .panel").first().addClass('active');
  },2000);
})(jQuery);
